/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * A helper to map received data to chart category data
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.1.0
 */

import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';

import { EChartDataKeyEnum, IChartDataInput } from '../../../components/common/Chart/chartTypes';
import { ITableReducer } from '../../../components/Table/reducers/tableReducer';
import { TableNameType } from '../../../components/Table/types/tableTypes';
import {
    ExpensesAnalyzerChartCategoryConfiguration,
//eslint-disable-next-line max-len
} from '../components/ExpensesAnalyzerController/ExpensesAnalyzerChartTab/constants/expensesAnalyzerChartCategoryConfiguration';
import {
    IExpensesAnalyzerChartCategoryConfiguration,
} from '../components/ExpensesAnalyzerController/ExpensesAnalyzerChartTab/expensesAnalyzerChartTypes';
import {
    IExpensesAnalyzerData,
} from '../components/ExpensesAnalyzerTable/types/expensesAnalyzerTableTypes';
import { TChartIdField } from '../types/pageExpensesAnalyzerTypes';


/**
 * @description  A helper to map received data to chart category data
 * @param {IExpensesAnalyzerData[]} tableData
 * @param {TChartIdField} chartIdField - main field to render in Chart
 * @param  {ITableReducer[TableNameType.expensesAnalyzer]['fields']} fields - table fields to select only checked
 * @return {IChartDataInput[]} data with appropriate format for Category Chart
 */
export const mapTableDataToChartCategoryData =
    (tableData: IExpensesAnalyzerData[], chartIdField: TChartIdField,
     fields: ITableReducer[TableNameType.expensesAnalyzer]['fields']): IChartDataInput[] => {
    const checkedFields = mapValues(keyBy(fields, 'name'), 'checked');
    return Object.values(
            tableData.reduce((r, a) => {
                ExpensesAnalyzerChartCategoryConfiguration
                    .forEach((config: IExpensesAnalyzerChartCategoryConfiguration) => {
                        if (!checkedFields[config.key]) return;
                        r[config.key] = r[config.key] || {};
                        r[config.key][EChartDataKeyEnum.checked] = true;
                        r[config.key][EChartDataKeyEnum.order] = config.order;
                        r[config.key][EChartDataKeyEnum.total] =
                            a[config.key] > (r[config.key][EChartDataKeyEnum.total] || 0)
                                ? a[config.key]
                                : r[config.key][EChartDataKeyEnum.total] || 0;
                        r[config.key][EChartDataKeyEnum.x] = config.key;
                        r[config.key][EChartDataKeyEnum.y] = r[config.key][EChartDataKeyEnum.y] || {};
                        r[config.key][EChartDataKeyEnum.y][a[chartIdField]] = a[config.key];
                    });
                return r;
            }, Object.create(null)),
        );
    };
